import { Link } from "react-router-dom";
import { FiArrowLeft, FiDownload, FiExternalLink } from "react-icons/fi";
import { PAGE_META } from "../../data/pageMeta";
import usePageMeta from "../../usePageMeta";
import "./CVPage.css";

const PDF = "/Diarmuid-Hession-CV.pdf";

// The CV as a PDF, with a bar to get back to the site or keep a copy.
// Most phone browsers can't show a PDF inside a page, so they get a button to open it instead.
export default function CVPage() {
  usePageMeta({ ...PAGE_META["/cv"], path: "/cv" });

  return (
    <main className="cv-page">
      <header className="cv-bar">
        <Link to="/" className="cv-back"><FiArrowLeft aria-hidden="true" /> <span>Back to the site</span></Link>
        <h1 className="cv-title">Diarmuid Hession <span>· CV</span></h1>
        <a href={PDF} download className="btn-brand cv-download"><FiDownload aria-hidden="true" /> Download PDF</a>
      </header>

      <iframe className="cv-frame" src={PDF} title="CV of Diarmuid Hession (PDF)" />

      <div className="cv-fallback">
        <p>On a phone, the CV reads best in your PDF viewer.</p>
        <a href={PDF} className="btn-brand" target="_blank" rel="noopener noreferrer">
          Open the CV <FiExternalLink aria-hidden="true" />
        </a>
      </div>
    </main>
  );
}
